import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

/** Configuración de Identity Platform leída de variables VITE_*. */
export interface FirebaseEnv {
  apiKey: string;
  authDomain: string;
  projectId: string;
}

export function readFirebaseEnv(env: Record<string, unknown> = import.meta.env): FirebaseEnv | null {
  const str = (v: unknown) => (typeof v === 'string' && v.trim() ? v : undefined);
  const apiKey = str(env.VITE_FIREBASE_API_KEY);
  const authDomain = str(env.VITE_FIREBASE_AUTH_DOMAIN);
  const projectId = str(env.VITE_FIREBASE_PROJECT_ID);
  if (!apiKey || !authDomain || !projectId) return null;
  return { apiKey, authDomain, projectId };
}

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

/** Inicialización perezosa: no se toca Firebase hasta que una pantalla lo necesita. */
export function getFirebaseAuth(): Auth {
  if (auth) return auth;
  const cfg = readFirebaseEnv();
  if (!cfg) {
    throw new Error('Falta configurar Identity Platform (VITE_FIREBASE_API_KEY, VITE_FIREBASE_AUTH_DOMAIN, VITE_FIREBASE_PROJECT_ID).');
  }
  app = getApps()[0] ?? initializeApp(cfg);
  auth = getAuth(app);
  return auth;
}

/** Devuelve el ID token vigente o null si no hay sesión (o Firebase no está configurado). */
export async function getIdToken(forceRefresh = false): Promise<string | null> {
  if (!readFirebaseEnv()) return null;
  const user = getFirebaseAuth().currentUser;
  return user ? user.getIdToken(forceRefresh) : null;
}
